var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"loading":_vm.loading}},[_c('v-row',[_c('DetailOverview',{attrs:{"contract":_vm.contract,"questionnaire":_vm.questionnaire,"user-vb":_vm.userVb}}),_vm._v(" "),_c('PositionOverview',{attrs:{"positions":_vm.positions,"contract":_vm.contract.id,"invoiced-positions":_vm.invoicedPositions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }